<template>
    <div class="box" @click="show" :style="non_configured">
        <div class="container has-text-centered">
            <img width="96" height="96" :src="img" />
            <br />
            <!-- margin нивелирует padding на box для label для избежания переноса строки-->
            <label style="margin: -1.25em;">{{ name }}</label>
        </div>
    </div>
</template>
<script>
export default {
    name: "FactorCard",
    props: {
        name: {
            required: true
        },
        img: {
            required: true
        },
        configured: {
            required: true
        }
    },
    computed: {
        non_configured: function() {
            if (this.configured) {
                return {
                    opacity: '1',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
                }
            }
            return {
                opacity: '.5'
            }
        }
    },
    methods: {
        show() {
            this.$emit("show");
        }
    }
}
</script>
